var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-tabs', {
    staticClass: "tab tab--inline tab--underline-inline",
    attrs: {
      "value": _vm.value,
      "centered": "",
      "show-arrows": "",
      "center-active": ""
    }
  }, _vm._l(_vm.items, function (item) {
    return _c('v-tab', _vm._b({
      key: item.text,
      attrs: {
        "exact-path": ""
      }
    }, 'v-tab', item, false), [_c('span', [_vm._v(_vm._s(item.name))])]);
  }), 1);
}
var staticRenderFns = []

export { render, staticRenderFns }